export enum PaymentStates {
    SELECT_PAYMENT,
    CREDIT,
    DPAY,
    SPLIT_CREDIT_STAGE,
    SPLIT_AMOUNT_STAGE,
    SUCCESS,
}
